// import { useState, useEffect, useCallback, useRef, useMemo } from 'react';
// import axios from 'axios';
// import { Box, Button, CircularProgress, IconButton, Tooltip, Dialog, Snackbar, Alert, DialogTitle, DialogContent, DialogActions, Typography, Checkbox, InputAdornment, TextField, useTheme, useMediaQuery } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import AddIcon from '@mui/icons-material/Add';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import SearchIcon from '@mui/icons-material/Search';
// import { useAuth } from '../context/AuthContext';
// import CustomNoDataOverlay from '../components/CustomNoDataOverlay';
// import NoDataComponent from '../components/NoDataComponent';
// import { VscNewFile } from 'react-icons/vsc';
// import { FaFileExcel } from 'react-icons/fa';
// import { formatRows } from '../utils/formatRows';
// import AccGroupMaster from './AccGrpMaster';

// /**
//  * Utility: Convert string to color
//  */
// function stringToColor(string) {
//     let hash = 0;
//     for (let i = 0; i < string.length; i++) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
//     return colors[Math.abs(hash) % colors.length];
// }

// /**
//  * Utility: Get initials from name
//  */
// function getInitials(name) {
//     if (!name) return 'C';
//     return name.trim().charAt(0).toUpperCase();
// }

// export default function AccGrpDetails({ connectionString, companyId, mode, setMode }) {
//     const { user, selectedCompany } = useAuth();
//     const userId = user?.UserId || null;
//     const role = user?.UserCategory;

//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//     const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));

//     const API = `${connectionString}/api`;

//     // ================= STATE MANAGEMENT =================

//     const [data, setData] = useState([]);
//     const [totalCount, setTotalCount] = useState(0);
//     const [loading, setLoading] = useState(false);
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//     // Desktop state (DataGrid)
//     const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
//     const [filterModel, setFilterModel] = useState({ items: [] });
//     const [sortModel, setSortModel] = useState([]);

//     // Mobile state (Search + Pagination)
//     const [mobileSearchQuery, setMobileSearchQuery] = useState('');
//     const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
//     const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: 20 });

//     // Selection & Dialog
//     const [selectionModel, setSelectionModel] = useState([]);
//     const selectedIdsRef = useRef([]);
//     const [selectAll, setSelectAll] = useState(false);
//     const [confirmOpen, setConfirmOpen] = useState(false);
//     const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
//     const [isFiltered, setIsFiltered] = useState(false);
//     const [openDialog, setOpenDialog] = useState(false);
//     const [editingId, setEditingId] = useState(null);

//     // ================= PARAMETER BUILDERS =================

//     /**
//      * Build parameters for mobile search request
//      */
//     const buildMobileParams = (pageNum, searchText) => {
//         const offset = pageNum * 20;
//         const params = {
//             mode: 'search',
//             companyId,
//             userId,
//             offset,
//             limit: 20
//         };

//         if (searchText && searchText.trim()) {
//             params.search = searchText;
//         }

//         return params;
//     };

//     /**
//      * Build parameters for desktop request with filters and sort
//      */
//     const buildDesktopParams = (pageNum, pageSize) => {
//         const offset = pageNum * pageSize;
//         const params = {
//             mode: 'search',
//             companyId,
//             userId,
//             offset,
//             limit: pageSize
//         };

//         // Add filters from DataGrid
//         filterModel.items.forEach(item => {
//             if (item.value) {
//                 const fieldMap = {
//                     'GrpName': 'GrpName',
//                     'GrpHead': 'GrpHead',
//                     'ParentGroupName': 'ParentGroupName',
//                     'NatureOfGroup': 'NatureOfGroup',
//                     'City': 'City',
//                     'state': 'state'
//                 };
//                 const dbColumn = fieldMap[item.field] || item.field;
//                 params[dbColumn] = item.value;
//             }
//         });

//         // Add sorting
//         if (sortModel.length > 0) {
//             const sort = sortModel[0];
//             params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
//         }

//         return params;
//     };

//     // ================= FETCH FUNCTIONS =================

//     /**
//      * Fetch data for desktop view (with filters and sort)
//      */
//     const fetchDataDesktop = useCallback(async () => {
//         if (isMobile) return;

//         setLoading(true);
//         try {
//             const params = buildDesktopParams(paginationModel.page, paginationModel.pageSize);

//             // Fetch rows
//             const dataRes = await axios.get(`${API}/AccUnderGroup/search`, { params });
//             const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
//             console.log(dataRes);
//             setData(
//                 formatRows(fetchedRows).map(r => ({
//                     ...r,
//                     id: r.AccGrpID
//                 }))
//             );
//             setSelectionModel([]);
//             selectedIdsRef.current = [];

//             // Fetch total count
//             const countParams = { companyId, userId };

//             filterModel.items.forEach(item => {
//                 if (item.value) {
//                     const fieldMap = {
//                         'GrpName': 'GrpName',
//                         'GrpHead': 'GrpHead',
//                         'ParentGroupName': 'ParentGroupName',
//                         'NatureOfGroup': 'NatureOfGroup',
//                         'City': 'City',
//                         'state': 'state'
//                     };
//                     const dbColumn = fieldMap[item.field] || item.field;
//                     countParams[dbColumn] = item.value;
//                 }
//             });

//             const countRes = await axios.get(`${API}/AccUnderGroup/count`, { params: countParams });
//             const count = Number(countRes.data) || 0;
//             setTotalCount(count);
//         } catch (err) {
//             console.error('Fetch error:', err);
//             setSnackbar({ open: true, message: 'Failed to fetch data.', severity: 'error' });
//             setData([]);
//             setTotalCount(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [API, companyId, userId, paginationModel, filterModel, sortModel, isMobile]);

//     /**
//      * Fetch data for mobile view (with search only)
//      */
//     const fetchDataMobile = useCallback(async () => {
//         if (!isMobile) return;

//         setLoading(true);
//         try {
//             const params = buildMobileParams(mobilePaginationModel.page, debouncedMobileSearch);

//             // Fetch rows
//             const dataRes = await axios.get(`${API}/AccUnderGroup/search`, { params });
//             const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
//             setData(
//                 formatRows(fetchedRows).map(r => ({
//                     ...r,
//                     id: r.AccGrpID
//                 }))
//             );
//             setSelectionModel([]);
//             selectedIdsRef.current = [];

//             // Fetch total count
//             const countParams = { companyId, userId };
//             if (debouncedMobileSearch && debouncedMobileSearch.trim()) {
//                 countParams.search = debouncedMobileSearch;
//             }

//             const countRes = await axios.get(`${API}/AccUnderGroup/count`, { params: countParams });
//             const count = Number(countRes.data) || 0;
//             setTotalCount(count);
//         } catch (err) {
//             console.error('Fetch error:', err);
//             setSnackbar({ open: true, message: `Error: ${err.message}`, severity: 'error' });
//             setData([]);
//             setTotalCount(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [API, companyId, userId, mobilePaginationModel, debouncedMobileSearch, isMobile]);

//     // ================= EFFECTS =================

//     /**
//      * Trigger desktop fetch when pagination, filters, or sort changes
//      */
//     useEffect(() => {
//         if (!isMobile) {
//             fetchDataDesktop();
//         }
//     }, [paginationModel.page, paginationModel.pageSize, filterModel, sortModel, isMobile, fetchDataDesktop]);

//     /**
//      * Trigger mobile fetch when pagination changes
//      */
//     useEffect(() => {
//         if (isMobile) {
//             fetchDataMobile();
//         }
//     }, [mobilePaginationModel, isMobile, fetchDataMobile]);

//     /**
//      * Debounce mobile search and trigger fetch
//      */
//     useEffect(() => {
//         const timer = setTimeout(() => {
//             setDebouncedMobileSearch(mobileSearchQuery);
//             setMobilePaginationModel({ page: 0, pageSize: 20 });
//         }, 400);

//         return () => clearTimeout(timer);
//     }, [mobileSearchQuery]);

//     /**
//      * Trigger fetch when debounced search changes
//      */
//     useEffect(() => {
//         if (isMobile) {
//             fetchDataMobile();
//         }
//     }, [debouncedMobileSearch, isMobile, fetchDataMobile]);

//     // ================= DELETE HANDLER =================

//     const handleDelete = async (ids) => {
//         const numericIds = ids.map(Number);
//         if (!numericIds.length) return;

//         setConfirmOpen(false);
//         try {
//             const response = await axios.post(`${API}/AccUnderGroup/delete`, {
//                 userId,
//                 objAryId: numericIds
//             });

//             setSnackbar({
//                 open: true,
//                 message: 'Deleted successfully.',
//                 severity: 'success'
//             });

//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             setSelectAll(false);

//             // Refetch data
//             if (isMobile) {
//                 fetchDataMobile();
//             } else {
//                 fetchDataDesktop();
//             }
//         } catch (error) {
//             const status = error.response?.status;
//             const errorData = error.response?.data;

//             if (status === 400 && errorData?.referencedIds?.length > 0) {
//                 setSnackbar({
//                     open: true,
//                     message: "Cannot delete the selected item(s) because they are referenced in other records.",
//                     severity: "warning"
//                 });
//             } else if (status === 400 && errorData?.error) {
//                 setSnackbar({
//                     open: true,
//                     message: errorData.error,
//                     severity: "warning"
//                 });
//             } else {
//                 setSnackbar({
//                     open: true,
//                     message: "Delete failed due to an unexpected error.",
//                     severity: "error"
//                 });
//             }
//         }
//     };

//     // ================= EXPORT HANDLER =================

//     // const funExportData = () => {
//     //     axios({
//     //         url: `${API}/search?mode=export&companyId=${companyId}&userId=${userId}`,
//     //         method: 'GET',
//     //         responseType: 'blob',
//     //     })
//     //         .then((response) => {
//     //             const url = window.URL.createObjectURL(new Blob([response.data]));
//     //             const link = document.createElement('a');
//     //             link.href = url;
//     //             link.setAttribute('download', 'exportedAccountGroups.xlsx');
//     //             document.body.appendChild(link);
//     //             link.click();
//     //             link.remove();
//     //         })
//     //         .catch((error) => {
//     //             console.error('Export error:', error);
//     //             setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
//     //         });
//     // };

//     // ================= SELECT ALL TOGGLE =================

//     const toggleSelectAll = () => {
//         if (selectAll) {
//             setSelectionModel([]);
//             selectedIdsRef.current = [];
//             setSelectAll(false);
//         } else {
//             const source = isMobile ? data : data;
//             const allIds = source.map(item => item.AccGrpID);

//             setSelectionModel(allIds);
//             selectedIdsRef.current = allIds;
//             setSelectAll(true);
//         }
//     };

//     // ================= FILTERED DATA (MOBILE) =================

//     const filteredData = useMemo(() => {
//         if (!isMobile) return data;

//         if (!mobileSearchQuery.trim()) return data;

//         const q = mobileSearchQuery.toLowerCase();

//         return data.filter(row =>
//             String(row.GrpName || '').toLowerCase().includes(q) ||
//             String(row.GrpHead || '').toLowerCase().includes(q) ||
//             String(row.ParentGroupName || '').toLowerCase().includes(q) ||
//             String(row.NatureOfGroup || '').toLowerCase().includes(q)
//         );
//     }, [data, mobileSearchQuery, isMobile]);

//     // ================= COLUMNS DEFINITION =================

//     const columns = [
//         {
//             field: 'GrpName',
//             headerName: 'Group Name',
//             flex: 1,
//             minWidth: 150,
//             renderCell: (params) => (
//                 <Typography
//                     sx={{
//                         cursor: 'pointer',
//                         color: '#1877F2',
//                         textDecoration: 'underline',
//                         fontSize: '0.85rem'
//                     }}
//                     onClick={(e) => {
//                         e.stopPropagation();
//                         setEditingId(params.row.id);
//                         setOpenDialog(true);
//                     }}
//                 >
//                     {params.value}
//                 </Typography>
//             )
//         },
//         {
//             field: 'GrpHead',
//             headerName: 'Group Head',
//             flex: 1,
//             minWidth: 150
//         },
//         {
//             field: 'PrimaryNo',
//             headerName: 'Primary',
//             width: 120,
//             renderCell: (params) => {
//                 const val = params?.row?.PrimaryNo;

//                 const isPrimary = val === 1 || val === '1' || val === true;

//                 return (
//                     <Typography
//                         sx={{
//                             color: isPrimary ? 'success.main' : 'text.secondary',
//                             fontWeight: isPrimary ? 600 : 400
//                         }}
//                     >
//                         {isPrimary ? 'True' : 'False'}
//                     </Typography>
//                 );
//             }
//         },
//         {
//             field: 'ParentGroupName',
//             headerName: 'Parent Group',
//             flex: 1,
//             minWidth: 150
//         },
//         {
//             field: 'NatureOfGroup',
//             headerName: 'Nature',
//             flex: 1,
//             minWidth: 150
//         }
//     ];

//     // Add delete button column if not User
//     if (role !== "User") {
//         columns.push({
//             field: 'actions',
//             headerName: 'Actions',
//             width: 120,
//             sortable: false,
//             filterable: false,
//             renderCell: (params) => {
//                 const isRowSelected = selectionModel.includes(params.row.AccGrpID);
//                 return (
//                     <Tooltip
//                         title={isRowSelected ? 'Delete selected' : 'Select row to enable'}
//                     >
//                         <span>
//                             <IconButton
//                                 color="error"
//                                 disabled={!isRowSelected}
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     e.preventDefault();

//                                     const idsToDelete =
//                                         selectedIdsRef.current.length > 0
//                                             ? selectedIdsRef.current
//                                             : [params.row.AccGrpID];

//                                     setPendingDeleteIds(idsToDelete);
//                                     setConfirmOpen(true);
//                                 }}
//                             >
//                                 <DeleteIcon fontSize="small" />
//                             </IconButton>
//                         </span>
//                     </Tooltip>
//                 );
//             },
//         });
//     }

//     // ================= MOBILE CARDS RENDERING =================

//     const renderMobileCards = () => {
//         if (loading) {
//             return (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
//                     <CircularProgress />
//                 </Box>
//             );
//         }

//         if (filteredData.length === 0) {
//             return (
//                 <Box sx={{ textAlign: 'center', py: 4 }}>
//                     {mobileSearchQuery ? <CustomNoDataOverlay /> : <NoDataComponent />}
//                 </Box>
//             );
//         }

//         return (
//             <>
//                 {filteredData.map((row) => {
//                     const isSelected = selectionModel.includes(row.AccGrpID);
//                     const avatarColor = stringToColor(row.GrpName || 'Group');
//                     const initials = getInitials(row.GrpName);

//                     return (
//                         <Box
//                             key={row.id}
//                             sx={{
//                                 mb: 1.5,
//                                 p: 2,
//                                 borderRadius: 2,
//                                 boxShadow: 2,
//                                 borderLeft: '4px solid',
//                                 borderLeftColor: 'primary.main',
//                                 backgroundColor: '#fff',
//                                 cursor: 'pointer',
//                                 transition: '0.2s',
//                                 '&:hover': { boxShadow: 4 }
//                             }}
//                             onClick={() => {
//                                 if (role === 'User') {
//                                     setSnackbar({
//                                         open: true,
//                                         message: '403 Forbidden: Access Denied',
//                                         severity: 'warning'
//                                     });
//                                     return;
//                                 }

//                                 setEditingId(row.id);
//                                 setOpenDialog(true);
//                             }}
//                         >
//                             {/* FIRST LINE: Checkbox + Group Name */}
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                                 {role !== 'User' && (
//                                     <Checkbox
//                                         size="small"
//                                         checked={isSelected}
//                                         onChange={(e) => {
//                                             e.stopPropagation();
//                                             const updated = isSelected
//                                                 ? selectionModel.filter(id => id !== row.AccGrpID)
//                                                 : [...selectionModel, row.AccGrpID];

//                                             setSelectionModel(updated);
//                                             selectedIdsRef.current = updated;
//                                         }}
//                                     />
//                                 )}

//                                 <Typography
//                                     fontWeight={600}
//                                     sx={{
//                                         color: 'primary.main',
//                                         textDecoration: 'underline',
//                                         cursor: 'pointer'
//                                     }}
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         setEditingId(row.id);
//                                         setOpenDialog(true);
//                                     }}
//                                 >
//                                     {row.GrpName || '—'}
//                                 </Typography>
//                             </Box>

//                             {/* SECOND LINE: Details */}
//                             <Box
//                                 sx={{
//                                     display: 'flex',
//                                     gap: 2,
//                                     mt: 0.6,
//                                     flexWrap: 'wrap',
//                                     ml: 1
//                                 }}
//                             >
//                                 <Box>
//                                     <Typography variant="caption" color="text.secondary">
//                                         Group Head
//                                     </Typography>
//                                     <Typography variant="body2" fontWeight={600}>
//                                         {row.GrpHead || '—'}
//                                     </Typography>
//                                 </Box>

//                                 <Box>
//                                     <Typography variant="caption" color="text.secondary">
//                                         Parent Group
//                                     </Typography>
//                                     <Typography variant="body2" fontWeight={600}>
//                                         {row.ParentGroupName || '—'}
//                                     </Typography>
//                                 </Box>

//                                 <Box>
//                                     <Typography variant="caption" color="text.secondary">
//                                         Nature
//                                     </Typography>
//                                     <Typography variant="body2" fontWeight={600}>
//                                         {row.NatureOfGroup || '—'}
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                         </Box>
//                     );
//                 })}

//                 {/* Pagination */}
//                 <Box
//                     sx={{
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         gap: 2,
//                         py: 2,
//                         mt: 2
//                     }}
//                 >
//                     <Button
//                         variant="outlined"
//                         disabled={mobilePaginationModel.page === 0}
//                         onClick={() =>
//                             setMobilePaginationModel((p) => ({
//                                 ...p,
//                                 page: Math.max(0, p.page - 1)
//                             }))
//                         }
//                     >
//                         ← Previous
//                     </Button>

//                     <Typography variant="body2">
//                         Page {mobilePaginationModel.page + 1} of{' '}
//                         {Math.ceil(totalCount / mobilePaginationModel.pageSize) || 1}
//                     </Typography>

//                     <Button
//                         variant="outlined"
//                         disabled={
//                             (mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount
//                         }
//                         onClick={() =>
//                             setMobilePaginationModel((p) => ({
//                                 ...p,
//                                 page: p.page + 1
//                             }))
//                         }
//                     >
//                         Next →
//                     </Button>
//                 </Box>
//             </>
//         );
//     };

//     // ================= RENDER =================

//     return (
//         <Box>
//             {/* Toolbar */}
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 {/* Title */}
//                 <Typography
//                     variant="h5"
//                     sx={{
//                         textAlign: 'center',
//                         flex: 1,
//                         fontSize: { xs: '1.25rem', sm: '1.5rem' },
//                         fontWeight: 600
//                     }}
//                 >
//                     {isSmallDevice ? "Account" : ""}
//                 </Typography>
//             </Box>

//             {/* Top Action Bar */}
//             <Box
//                 sx={{
//                     display: 'flex',
//                     justifyContent: 'flex-end',
//                     gap: 1,
//                     mb: 2,
//                     flexWrap: 'wrap'
//                 }}
//             >
//                 {/* <Button
//                     variant="outlined"
//                     startIcon={<FaFileExcel />}
//                     onClick={funExportData}
//                     color="success"
//                     sx={{
//                         textTransform: 'none',
//                         fontWeight: 500
//                     }}
//                 >
//                     Export
//                 </Button> */}

//                 <Button
//                     variant="contained"
//                     startIcon={<AddIcon />}
//                     onClick={() => {
//                         setEditingId(null); // important for ADD mode
//                         setOpenDialog(true);
//                     }}
//                     sx={{
//                         textTransform: 'none',
//                         fontWeight: 500
//                     }}
//                 >
//                     Add Group
//                 </Button>
//             </Box>

//             {/* Content */}
//             {data.length === 0 ? (
//                 <NoDataComponent />
//             ) : isMobile ? (
//                 <>
//                     {/* Mobile Search */}
//                     <Box sx={{ mt: 1, mb: 2, px: 1 }}>
//                         <TextField
//                             fullWidth
//                             size="small"
//                             placeholder="Search Account Group..."
//                             value={mobileSearchQuery}
//                             onChange={(e) => setMobileSearchQuery(e.target.value)}
//                             variant="outlined"
//                             InputProps={{
//                                 startAdornment: (
//                                     <InputAdornment position="start">
//                                         <SearchIcon />
//                                     </InputAdornment>
//                                 ),
//                             }}
//                         />
//                     </Box>

//                     {/* Selection Bar */}
//                     {role !== 'User' && selectionModel.length > 0 && (
//                         <Box
//                             sx={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'space-between',
//                                 px: 2,
//                                 py: 1.5,
//                                 mb: 2,
//                                 bgcolor: 'background.paper',
//                                 borderRadius: 2,
//                                 boxShadow: 1
//                             }}
//                         >
//                             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                 <Checkbox
//                                     checked={selectAll}
//                                     onChange={toggleSelectAll}
//                                     size="small"
//                                 />
//                                 <Typography variant="body2" sx={{ ml: 1 }}>
//                                     {selectionModel.length} selected
//                                 </Typography>
//                             </Box>
//                             <Tooltip title="Delete selected">
//                                 <IconButton
//                                     onClick={(e) => {
//                                         e.stopPropagation();
//                                         e.preventDefault();

//                                         setPendingDeleteIds(selectionModel);
//                                         setConfirmOpen(true);
//                                     }}
//                                     color="error"
//                                 >
//                                     <DeleteIcon />
//                                 </IconButton>
//                             </Tooltip>
//                         </Box>
//                     )}

//                     {/* Mobile Cards */}
//                     <Box>{renderMobileCards()}</Box>
//                 </>
//             ) : (
//                 /* Desktop View - DataGrid */
//                 <Box sx={{ height: 400 }}>
//                     <DataGrid
//                         rows={data}
//                         columns={columns}
//                         pageSizeOptions={[25, 50, 100]}
//                         pagination
//                         paginationModel={paginationModel}
//                         onPaginationModelChange={setPaginationModel}
//                         rowCount={totalCount}
//                         paginationMode="server"
//                         filterMode="server"
//                         sortingMode="server"
//                         loading={loading}
//                         disableSelectionOnClick
//                         checkboxSelection
//                         disableRowSelectionOnClick
//                         onRowSelectionModelChange={(newSelection) => {
//                             const numeric = newSelection.map(Number);
//                             setSelectionModel(numeric);
//                             selectedIdsRef.current = numeric;
//                         }}
//                         onFilterModelChange={setFilterModel}
//                         onSortModelChange={setSortModel}
//                         sx={{
//                             '& .MuiDataGrid-columnHeaders': {
//                                 backgroundColor: '#E0E0E0'
//                             },
//                             '& .MuiDataGrid-columnHeaderTitle': {
//                                 fontWeight: 700
//                             },
//                             '& .MuiDataGrid-columnHeader': {
//                                 backgroundColor: '#E0E0E0',
//                                 color: '#000000',
//                                 fontWeight: 'bold'
//                             },
//                             '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
//                             '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },
//                             '& .MuiDataGrid-row:nth-of-type(odd)': {
//                                 backgroundColor: '#FFFFFF'
//                             },
//                             '& .MuiDataGrid-row:nth-of-type(even)': {
//                                 backgroundColor: '#F9FAFB'
//                             },
//                             '& .MuiDataGrid-row:hover': {
//                                 backgroundColor: '#f1f5f9'
//                             },
//                             '& .MuiDataGrid-row.Mui-selected': {
//                                 backgroundColor: '#BDBDBD !important'
//                             },
//                             '& .MuiDataGrid-cell': {
//                                 display: 'flex',
//                                 alignItems: 'center'
//                             }
//                         }}
//                         slots={{
//                             noResultsOverlay: CustomNoDataOverlay
//                         }}
//                     />
//                 </Box>
//             )}

//             {/* Snackbar */}
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={3000}
//                 onClose={() => setSnackbar(s => ({ ...s, open: false }))}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//             >
//                 <Alert
//                     onClose={() => setSnackbar(s => ({ ...s, open: false }))}
//                     severity={snackbar.severity}
//                     variant="filled"
//                     sx={{ width: '100%' }}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>

//             {/* Delete Confirmation Dialog */}
//             <Dialog
//                 open={confirmOpen}
//                 onClose={() => setConfirmOpen(false)}
//                 maxWidth="xs"
//                 fullWidth
//             >
//                 <DialogTitle>Confirm Deletion</DialogTitle>

//                 <DialogContent>
//                     <Typography variant="body2">
//                         Are you sure you want to delete{' '}
//                         <strong>{pendingDeleteIds.length}</strong> account group record(s)?
//                     </Typography>
//                 </DialogContent>

//                 <DialogActions>
//                     <Button onClick={() => setConfirmOpen(false)} variant="outlined">
//                         Cancel
//                     </Button>

//                     <Button
//                         color="error"
//                         variant="contained"
//                         onClick={() => {
//                             handleDelete(pendingDeleteIds);
//                         }}
//                     >
//                         Delete
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//             <Dialog open={openDialog} maxWidth="sm" fullWidth>
//                 <AccGroupMaster   // 👈 your form component
//                     mode={editingId ? 'edit' : 'comp'}
//                     id={editingId}
//                     connectionString={connectionString}
//                     companyId={companyId}
//                     onPopupCancel={() => {
//                         setOpenDialog(false);
//                         setEditingId(null);

//                         // refresh data after save
//                         if (isMobile) {
//                             fetchDataMobile();
//                         } else {
//                             fetchDataDesktop();
//                         }
//                     }}
//                 />
//             </Dialog>
//         </Box>
//     );
// }





import { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import axios from 'axios';
import { Box, Button, Card, CardContent, Avatar, Chip, Divider, CircularProgress, IconButton, Tooltip, Dialog, Paper, Snackbar, Alert, Typography, Checkbox, InputAdornment, TextField, useTheme, useMediaQuery, LinearProgress } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useAuth } from '../context/AuthContext';
import CustomNoDataOverlay from '../components/CustomNoDataOverlay';
import NoDataComponent from '../components/NoDataComponent';
import { VscNewFile } from 'react-icons/vsc';
import { FaFileExcel } from 'react-icons/fa';
import { formatRows } from '../utils/formatRows';
import AccGroupMaster from './AccGrpMaster';

/**
 * Utility: Convert string to color
 */
function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
    return colors[Math.abs(hash) % colors.length];
}

/**
 * Utility: Get initials from name
 */
function getInitials(name) {
    if (!name) return 'C';
    return name.trim().charAt(0).toUpperCase();
}

export default function AccGrpDetails({ connectionString, companyId, mode, setMode }) {
    const { user, selectedCompany } = useAuth();
    const userId = user?.UserId || null;
    const role = user?.UserCategory;

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));

    const API = `${connectionString}/api`;

    // ================= STATE MANAGEMENT =================

    const [data, setData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    // Desktop state (DataGrid)
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [sortModel, setSortModel] = useState([]);

    // Mobile state (Search + Pagination)
    const [mobileSearchQuery, setMobileSearchQuery] = useState('');
    const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
    const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: 20 });

    // Selection & Dialog
    const [selectionModel, setSelectionModel] = useState([]);
    const selectedIdsRef = useRef([]);
    const [selectAll, setSelectAll] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
    const [deleting, setDeleting] = useState(false);
    const [isFiltered, setIsFiltered] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [editingId, setEditingId] = useState(null);

    // Delete details dialog (optional)
    const [deleteDetailsOpen, setDeleteDetailsOpen] = useState(false);
    const [deleteDetails, setDeleteDetails] = useState(null);

    // ================= PARAMETER BUILDERS =================

    /**
     * Build parameters for mobile search request
     */
    const buildMobileParams = (pageNum, searchText) => {
        const offset = pageNum * 20;
        const params = {
            mode: 'search',
            companyId,
            userId,
            offset,
            limit: 20
        };

        if (searchText && searchText.trim()) {
            params.search = searchText;
        }

        return params;
    };

    /**
     * Build parameters for desktop request with filters and sort
     */
    const buildDesktopParams = (pageNum, pageSize) => {
        const offset = pageNum * pageSize;
        const params = {
            mode: 'search',
            companyId,
            userId,
            offset,
            limit: pageSize
        };

        // Add filters from DataGrid
        filterModel.items.forEach(item => {
            if (item.value) {
                const fieldMap = {
                    'GrpName': 'GrpName',
                    'GrpHead': 'GrpHead',
                    'ParentGroupName': 'ParentGroupName',
                    'NatureOfGroup': 'NatureOfGroup',
                    'City': 'City',
                    'state': 'state'
                };
                const dbColumn = fieldMap[item.field] || item.field;
                params[dbColumn] = item.value;
            }
        });

        // Add sorting
        if (sortModel.length > 0) {
            const sort = sortModel[0];
            params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
        }

        return params;
    };

    // ================= FETCH FUNCTIONS =================

    /**
     * Fetch data for desktop view (with filters and sort)
     */
    const fetchDataDesktop = useCallback(async () => {
        if (isMobile) return;

        setLoading(true);
        try {
            const params = buildDesktopParams(paginationModel.page, paginationModel.pageSize);

            // Fetch rows
            const dataRes = await axios.get(`${API}/AccUnderGroup/search`, { params });
            const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
            console.log(dataRes);
            setData(
                formatRows(fetchedRows).map(r => ({
                    ...r,
                    id: r.AccGrpID
                }))
            );
            setSelectionModel([]);
            selectedIdsRef.current = [];

            // Fetch total count
            const countParams = { companyId, userId };

            filterModel.items.forEach(item => {
                if (item.value) {
                    const fieldMap = {
                        'GrpName': 'GrpName',
                        'GrpHead': 'GrpHead',
                        'ParentGroupName': 'ParentGroupName',
                        'NatureOfGroup': 'NatureOfGroup',
                        'City': 'City',
                        'state': 'state'
                    };
                    const dbColumn = fieldMap[item.field] || item.field;
                    countParams[dbColumn] = item.value;
                }
            });

            const countRes = await axios.get(`${API}/AccUnderGroup/count`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);
        } catch (err) {
            console.error('Fetch error:', err);
            setSnackbar({ open: true, message: 'Failed to fetch data.', severity: 'error' });
            setData([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [API, companyId, userId, paginationModel, filterModel, sortModel, isMobile]);

    /**
     * Fetch data for mobile view (with search only)
     */
    const fetchDataMobile = useCallback(async () => {
        if (!isMobile) return;

        setLoading(true);
        try {
            const params = buildMobileParams(mobilePaginationModel.page, debouncedMobileSearch);

            // Fetch rows
            const dataRes = await axios.get(`${API}/AccUnderGroup/search`, { params });
            const fetchedRows = Array.isArray(dataRes.data) ? dataRes.data : [];
            setData(
                formatRows(fetchedRows).map(r => ({
                    ...r,
                    id: r.AccGrpID
                }))
            );
            setSelectionModel([]);
            selectedIdsRef.current = [];

            // Fetch total count
            const countParams = { companyId, userId };
            if (debouncedMobileSearch && debouncedMobileSearch.trim()) {
                countParams.search = debouncedMobileSearch;
            }

            const countRes = await axios.get(`${API}/AccUnderGroup/count`, { params: countParams });
            const count = Number(countRes.data) || 0;
            setTotalCount(count);
        } catch (err) {
            console.error('Fetch error:', err);
            setSnackbar({ open: true, message: `Error: ${err.message}`, severity: 'error' });
            setData([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [API, companyId, userId, mobilePaginationModel, debouncedMobileSearch, isMobile]);

    // ================= EFFECTS =================

    /**
     * Trigger desktop fetch when pagination, filters, or sort changes
     */
    useEffect(() => {
        if (!isMobile) {
            fetchDataDesktop();
        }
    }, [paginationModel.page, paginationModel.pageSize, filterModel, sortModel, isMobile, fetchDataDesktop]);

    /**
     * Trigger mobile fetch when pagination changes
     */
    useEffect(() => {
        if (isMobile) {
            fetchDataMobile();
        }
    }, [mobilePaginationModel, isMobile, fetchDataMobile]);

    /**
     * Debounce mobile search and trigger fetch
     */
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedMobileSearch(mobileSearchQuery);
            setMobilePaginationModel({ page: 0, pageSize: 20 });
        }, 400);

        return () => clearTimeout(timer);
    }, [mobileSearchQuery]);

    /**
     * Trigger fetch when debounced search changes
     */
    useEffect(() => {
        if (isMobile) {
            fetchDataMobile();
        }
    }, [debouncedMobileSearch, isMobile, fetchDataMobile]);

    // ================= DELETE HANDLER =================

    /**
     * Enhanced delete handler that handles complex API responses
     * Supports: partial deletions, blocking reasons, missing IDs
     */
    const handleDelete = async (ids) => {
        const numericIds = ids.map(Number);
        if (!numericIds.length || deleting) return;

        setDeleting(true);
        try {
            const response = await axios.post(`${API}/AccUnderGroup/delete`, {
                userId,
                objAryId: numericIds
            });

            // ============ PARSE RESPONSE ============
            const data = response.data;

            // Successful deletions
            const deletedCount = data.deletedIds?.length || 0;
            const affectedRows = data.affectedRows || 0;

            // Blocking reasons
            const blockedByParent = data.blockedIds || [];  // Has child groups
            const referencedInLedger = data.referencedIds || [];  // Used in ledger
            const missingIds = data.missingIds || [];  // Don't exist

            // ============ BUILD MESSAGE ============
            let messageText = '';
            let severity = 'success';

            // Case 1: All deleted successfully
            if (deletedCount === numericIds.length) {
                messageText = `✅ Successfully deleted ${deletedCount} account group(s).`;
                severity = 'success';
            }
            // Case 2: Partial deletions with warnings
            else if (deletedCount > 0) {
                messageText = `✅ Deleted ${deletedCount} account group(s). `;
                severity = 'warning';

                if (blockedByParent.length > 0) {
                    messageText += `⚠️ ${blockedByParent.length} has child groups. `;
                }
                if (referencedInLedger.length > 0) {
                    messageText += `⚠️ ${referencedInLedger.length} used in ledger.`;
                }
            }
            // Case 3: No deletions - all blocked
            else {
                messageText = '❌ No records deleted. ';
                severity = 'warning';

                if (blockedByParent.length === numericIds.length) {
                    messageText += `All selected groups have child groups.`;
                } else if (referencedInLedger.length === numericIds.length) {
                    messageText += `All selected groups are used in ledger.`;
                } else {
                    messageText += `Some records are in use or have dependencies.`;
                }
            }

            // Show snackbar
            setSnackbar({ open: true, message: messageText, severity });

            // ============ UPDATE UI ============

            // Clear selection
            setSelectionModel([]);
            selectedIdsRef.current = [];
            setSelectAll(false);

            // Refetch data if something was deleted
            if (deletedCount > 0) {
                if (isMobile) {
                    fetchDataMobile();
                } else {
                    fetchDataDesktop();
                }
            }

        } catch (error) {
            const status = error.response?.status;
            const errorData = error.response?.data;

            console.log('Delete error response:', errorData);

            // ============ ERROR HANDLING ============

            let errorMessage = "Delete failed due to an unexpected error.";
            let errorSeverity = "error";

            // Case 1: 400 - Validation errors with specific reasons
            if (status === 400) {

                // Check for error field first (this is what the backend sends)
                if (errorData?.error) {
                    errorMessage = errorData.error;
                    errorSeverity = "warning";
                }

                // Reason 1: Has child groups (blockedIds in response)
                else if (errorData?.blockedIds?.length > 0) {
                    const blockedNames = errorData.blockedIds
                        .map(b => b.GrpName || `ID: ${b.AccGrpID}`)
                        .join(', ');

                    errorMessage = `Cannot delete: ${blockedNames} has child groups.`;
                    errorSeverity = "warning";
                }

                // Reason 2: Custom error message from backend
                else {
                    errorMessage = errorData?.error || "Cannot complete this operation.";
                    errorSeverity = "warning";
                }
            }

            setSnackbar({ open: true, message: errorMessage, severity: errorSeverity });

        } finally {
            setDeleting(false);
            setConfirmOpen(false);
        }
    };

    // ================= EXPORT HANDLER =================

    // const funExportData = () => {
    //     axios({
    //         url: `${API}/search?mode=export&companyId=${companyId}&userId=${userId}`,
    //         method: 'GET',
    //         responseType: 'blob',
    //     })
    //         .then((response) => {
    //             const url = window.URL.createObjectURL(new Blob([response.data]));
    //             const link = document.createElement('a');
    //             link.href = url;
    //             link.setAttribute('download', 'exportedAccountGroups.xlsx');
    //             document.body.appendChild(link);
    //             link.click();
    //             link.remove();
    //         })
    //         .catch((error) => {
    //             console.error('Export error:', error);
    //             setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
    //         });
    // };

    // ================= SELECT ALL TOGGLE =================

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectionModel([]);
            selectedIdsRef.current = [];
            setSelectAll(false);
        } else {
            const source = isMobile ? data : data;
            const allIds = source.map(item => item.AccGrpID);

            setSelectionModel(allIds);
            selectedIdsRef.current = allIds;
            setSelectAll(true);
        }
    };

    // ================= FILTERED DATA (MOBILE) =================

    const filteredData = useMemo(() => {
        if (!isMobile) return data;

        if (!mobileSearchQuery.trim()) return data;

        const q = mobileSearchQuery.toLowerCase();

        return data.filter(row =>
            String(row.GrpName || '').toLowerCase().includes(q) ||
            String(row.GrpHead || '').toLowerCase().includes(q) ||
            String(row.ParentGroupName || '').toLowerCase().includes(q) ||
            String(row.NatureOfGroup || '').toLowerCase().includes(q)
        );
    }, [data, mobileSearchQuery, isMobile]);

    // ================= COLUMNS DEFINITION =================

    const columns = [
        {
            field: 'SubGrpName',
            headerName: 'Group Name',
            flex: 1,
            minWidth: 150,
            renderCell: (params) => (
                <Typography
                    sx={{
                        cursor: 'pointer',
                        color: '#1877F2',
                        textDecoration: 'underline',
                        fontSize: '0.85rem'
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setEditingId(params.row.id);
                        setOpenDialog(true);
                    }}
                >
                    {params.value}
                </Typography>
            )
        },
        {
            field: 'PrimaryNo',
            headerName: 'Primary',
            width: 120,
            renderCell: (params) => {
                const val = params?.row?.IsPrimary;

                const isPrimary = val === 1 || val === '1' || val === true;

                return (
                    <Typography
                        sx={{
                            color: isPrimary ? 'success.main' : 'text.secondary',
                            fontWeight: isPrimary ? 600 : 400
                        }}
                    >
                        {isPrimary ? 'True' : 'False'}
                    </Typography>
                );
            }
        },
        {
            field: 'GrpName',
            headerName: 'Parent Group',
            flex: 1,
            minWidth: 150
        },
        {
            field: 'NatureOfGroup',
            headerName: 'Nature',
            flex: 1,
            minWidth: 150
        }
    ];

    // Add delete button column if not User
    if (role !== "User") {
        columns.push({
            field: 'actions',
            headerName: 'Actions',
            width: 120,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                const isRowSelected = selectionModel.includes(params.row.AccGrpID);
                return (
                    <Tooltip
                        title={isRowSelected ? 'Delete selected' : 'Select row to enable'}
                    >
                        <span>
                            <IconButton
                                color="error"
                                disabled={!isRowSelected}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();

                                    const idsToDelete =
                                        selectedIdsRef.current.length > 0
                                            ? selectedIdsRef.current
                                            : [params.row.AccGrpID];

                                    setPendingDeleteIds(idsToDelete);
                                    setConfirmOpen(true);
                                }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        });
    }

    // ================= MOBILE CARDS RENDERING =================

    const renderMobileCards = () => {
        if (loading) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
                    <CircularProgress />
                </Box>
            );
        }

        if (filteredData.length === 0) {
            return (
                <Box sx={{ textAlign: 'center', py: 4 }}>
                    {mobileSearchQuery ? <CustomNoDataOverlay /> : <NoDataComponent />}
                </Box>
            );
        }

        return (
            <>
                {filteredData.map((row) => {
                    const isSelected = selectionModel.includes(row.AccGrpID);
                    const avatarColor = stringToColor(row.GrpName || 'Group');
                    const initials = getInitials(row.GrpName);

                    return (
                        <Card key={row.id} sx={{ mb: 1.5, borderRadius: 2, boxShadow: 1, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 3 }, cursor: 'pointer' }}
                            onClick={() => {
                                if (role === 'User') {
                                    setSnackbar({ open: true, message: '403 Forbidden: Access Denied', severity: 'warning' });
                                    return;
                                }
                                setEditingId(row.id);
                                setOpenDialog(true);
                            }}
                        >
                            <Box sx={{ height: 5, background: `linear-gradient(90deg, ${avatarColor} 0%, ${avatarColor}88 100%)` }} />
                            <CardContent sx={{ py: 1.5, px: 1.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                    {role !== 'User' && (
                                        <Checkbox size="small" checked={isSelected} onChange={(e) => {
                                            e.stopPropagation();
                                            const updated = isSelected
                                                ? selectionModel.filter(id => id !== row.AccGrpID)
                                                : [...selectionModel, row.AccGrpID];
                                            setSelectionModel(updated);
                                            selectedIdsRef.current = updated;
                                        }} sx={{ p: 0.5, mr: 0.5, flexShrink: 0 }} onClick={(e) => e.stopPropagation()} />
                                    )}
                                    <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 38, height: 38, fontWeight: 700, mr: 1.5, flexShrink: 0, fontSize: '1rem' }}>
                                        {initials}
                                    </Avatar>
                                    <Box sx={{ minWidth: 0 }}>
                                        <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                                            onClick={(e) => { e.stopPropagation(); setEditingId(row.id); setOpenDialog(true); }}>
                                            {row.GrpName || '—'}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Divider sx={{ my: 0.8 }} />
                                <Box sx={{ mt: 0.8, display: 'flex', gap: 0.8, flexWrap: 'wrap' }}>
                                    {row.SubGrpName && <Chip variant="outlined" label={`Sub Group: ${row.SubGrpName}`} size="small" sx={{ height: 22, fontSize: '0.75rem' }} />}
                                    {row.ParentGroupName && <Chip variant="outlined" label={row.ParentGroupName} size="small" sx={{ height: 22, fontSize: '0.75rem' }} />}
                                    {row.NatureOfGroup && <Chip variant="outlined" label={row.NatureOfGroup} size="small" sx={{ height: 22, fontSize: '0.75rem' }} />}
                                </Box>
                            </CardContent>
                        </Card>
                    );
                })}

                {/* Pagination */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 2,
                        py: 2,
                        mt: 2
                    }}
                >
                    <Button variant="outlined" size="small" startIcon={<NavigateBeforeIcon />}
                        disabled={mobilePaginationModel.page === 0}
                        onClick={() => setMobilePaginationModel((p) => ({ ...p, page: Math.max(0, p.page - 1) }))}>
                        Previous
                    </Button>

                    <Typography variant="body2">
                        Page {mobilePaginationModel.page + 1} of{' '}
                        {Math.ceil(totalCount / mobilePaginationModel.pageSize) || 1}
                    </Typography>

                    <Button variant="outlined" size="small" endIcon={<NavigateNextIcon />}
                        disabled={(mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount}
                        onClick={() => setMobilePaginationModel((p) => ({ ...p, page: p.page + 1 }))}>
                        Next
                    </Button>
                </Box>
            </>
        );
    };

    // ================= RENDER =================

    return (
        <Box>
            {/* ── Module Header: gradient strip + title + Add button ─────────────── */}
            <Box sx={{ mb: 2 }}>
                <Box sx={{ height: 4, background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)', borderRadius: '6px 6px 0 0' }} />
                <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderTop: 0, borderRadius: '0 0 8px 8px', px: 2, py: 1.2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                        Account Groups
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        size="small"
                        onClick={() => { setEditingId(null); setOpenDialog(true); }}
                    >
                        Add Group
                    </Button>
                </Paper>
            </Box>

            {/* Content */}
            {data.length === 0 ? (
                <NoDataComponent />
            ) : isMobile ? (
                <>
                    {/* Mobile Search */}
                    <Box sx={{ mt: 1, mb: 2, px: 1 }}>
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Search Account Group..."
                            value={mobileSearchQuery}
                            onChange={(e) => setMobileSearchQuery(e.target.value)}
                            variant="outlined"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>

                    {/* Selection Bar */}
                    {role !== 'User' && selectionModel.length > 0 && (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                px: 2,
                                py: 1.5,
                                mb: 2,
                                bgcolor: 'background.paper',
                                borderRadius: 2,
                                boxShadow: 1
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Checkbox
                                    checked={selectAll}
                                    onChange={toggleSelectAll}
                                    size="small"
                                />
                                <Typography variant="body2" sx={{ ml: 1 }}>
                                    {selectionModel.length} selected
                                </Typography>
                            </Box>
                            <Tooltip title="Delete selected">
                                <IconButton
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();

                                        setPendingDeleteIds(selectionModel);
                                        setConfirmOpen(true);
                                    }}
                                    color="error"
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}

                    {/* Mobile Cards */}
                    <Box>{renderMobileCards()}</Box>
                </>
            ) : (
                /* Desktop View - DataGrid */
                <Box sx={{ height: 400 }}>
                    <DataGrid
                        rows={data}
                        columns={columns}
                        pageSizeOptions={[25, 50, 100]}
                        pagination
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                        rowCount={totalCount}
                        paginationMode="server"
                        filterMode="server"
                        sortingMode="server"
                        loading={loading}
                        disableSelectionOnClick
                        checkboxSelection
                        disableRowSelectionOnClick
                        onRowSelectionModelChange={(newSelection) => {
                            const numeric = newSelection.map(Number);
                            setSelectionModel(numeric);
                            selectedIdsRef.current = numeric;
                        }}
                        onFilterModelChange={setFilterModel}
                        onSortModelChange={setSortModel}
                        sx={{
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#E0E0E0'
                            },
                            '& .MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 700
                            },
                            '& .MuiDataGrid-columnHeader': {
                                backgroundColor: '#E0E0E0',
                                color: '#000000',
                                fontWeight: 'bold'
                            },
                            '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
                            '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },
                            '& .MuiDataGrid-row:nth-of-type(odd)': {
                                backgroundColor: '#FFFFFF'
                            },
                            '& .MuiDataGrid-row:nth-of-type(even)': {
                                backgroundColor: '#F9FAFB'
                            },
                            '& .MuiDataGrid-row:hover': {
                                backgroundColor: '#f1f5f9'
                            },
                            '& .MuiDataGrid-row.Mui-selected': {
                                backgroundColor: '#BDBDBD !important'
                            },
                            '& .MuiDataGrid-cell': {
                                display: 'flex',
                                alignItems: 'center'
                            }
                        }}
                        slots={{
                            noResultsOverlay: CustomNoDataOverlay
                        }}
                    />
                </Box>
            )}

            {/* Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar(s => ({ ...s, open: false }))}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setSnackbar(s => ({ ...s, open: false }))}
                    severity={snackbar.severity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>

            {/* ── Delete Confirmation Dialog ────────────────────────────────────────── */}
            <Dialog open={confirmOpen} onClose={() => { if (!deleting) setConfirmOpen(false); }} maxWidth="xs" fullWidth>
                {deleting
                    ? <LinearProgress color="error" sx={{ height: 4 }} />
                    : <Box sx={{ height: 4, background: 'linear-gradient(90deg, #d32f2f 0%, #f44336 100%)' }} />}
                <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                    <Typography variant="h6" fontWeight={700} sx={{ color: 'error.main', fontSize: '1.05rem' }}>
                        Confirm Deletion
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 2 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                        Are you sure you want to delete{' '}
                        <Typography component="span" variant="body2" fontWeight={700} color="error.main">
                            {pendingDeleteIds.length}
                        </Typography>
                        {' '}account group record(s)? This action cannot be undone.
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={() => setConfirmOpen(false)} variant="outlined" color="inherit" size="small" disabled={deleting}>Cancel</Button>
                    <Button color="error" variant="contained" size="small" disabled={deleting}
                        startIcon={deleting ? <CircularProgress size={14} color="inherit" /> : <DeleteIcon />}
                        onClick={() => handleDelete(pendingDeleteIds)}>{deleting ? 'Deleting…' : 'Delete'}</Button>
                </Box>
            </Dialog>

            {/* Form Dialog */}
            <Dialog open={openDialog} maxWidth="sm" fullWidth>
                <AccGroupMaster
                    mode={editingId ? 'edit' : 'comp'}
                    id={editingId}
                    connectionString={connectionString}
                    companyId={companyId}
                    onPopupCancel={() => {
                        setOpenDialog(false);
                        setEditingId(null);

                        // refresh data after save
                        if (isMobile) {
                            fetchDataMobile();
                        } else {
                            fetchDataDesktop();
                        }
                    }}
                />
            </Dialog>
        </Box>
    );
}